// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.105.1/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card {\n  margin-bottom: 0.5rem;\n}\n.card-header {\n  padding: 0.5rem 1.25rem;\n}\n.card-body {\n  padding: 0.5rem 1.25rem;\n}\n[data-markdown-statement] p {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
